import { render, staticRenderFns } from "./CreateUpdateMessageTemplate.vue?vue&type=template&id=ad56b030&scoped=true"
import script from "./CreateUpdateMessageTemplate.vue?vue&type=script&lang=js"
export * from "./CreateUpdateMessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdateMessageTemplate.vue?vue&type=style&index=0&id=ad56b030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad56b030",
  null
  
)

export default component.exports